import axios from 'axios';
import UserService from './users'
let locationAPI = 'https://aral.vedebo.net/api/v1/';
if(window.location.href.indexOf('localhost')>=0 ){
//  locationAPI ='http://localhost:3001/api/v1/';
}
const get = (attribute, headers,queries) => {
    return new Promise((resolve, reject) => {
        let prepHeaders = {};
        prepHeaders['authorisation'] = 'Bearer '+ UserService.getToken();
        if (headers) {
            Object.keys(headers).forEach((key) => {
                prepHeaders[key] = headers[key];
            })
        }
        let prepQuery = '';
        if(queries){ prepQuery = '?' + queries}
        axios.get(locationAPI + attribute + prepQuery, { headers: prepHeaders })
            .then(res => {
                resolve(res.data);
            }, err => {
                console.log('err',locationAPI + attribute, err);
                reject(err);
            })
    })
}

const post = (attribute, headers, data) => {
    return new Promise((resolve, reject) => {
        let prepHeaders = {};
        prepHeaders['authorisation'] =  'Bearer '+UserService.getToken();
        if (headers) {
            Object.keys(headers).forEach((key) => {
                prepHeaders[key] = headers[key];
            })
        }
        prepHeaders['Content-Type'] = 'application/json; charset=utf-8';
        prepHeaders['Accept'] = 'application/json; charset=utf-8';
        axios.post(locationAPI + attribute, {item:data}, { headers: prepHeaders })
            .then(res => {
                resolve(res.data);
            }, err => {
                console.log('err', err);
                reject(err);
            })
    })
}
const put = (attribute, headers, data) => {
    return new Promise((resolve, reject) => {
        let prepHeaders = {};
        prepHeaders['authorisation'] = 'Bearer '+UserService.getToken();
        if (headers) {
            Object.keys(headers).forEach((key) => {
                prepHeaders[key] = headers[key];
            })
        }
        prepHeaders['Content-Type'] = 'application/json; charset=utf-8';
        prepHeaders['Accept'] = 'application/json; charset=utf-8';

        axios.put(locationAPI + attribute, {item:data}, { headers: prepHeaders })
            .then(res => {
                resolve(res.data);
            }, err => {
                console.log('err', err);
                reject(err);
            })
    })
}

const deleteItem = (attribute, headers) => {
    return new Promise((resolve, reject) => {
        let prepHeaders = {};
        prepHeaders['authorisation'] =  'Bearer '+UserService.getToken();
        if (headers) {
            Object.keys(headers).forEach((key) => {
                prepHeaders[key] = headers[key];
            })
        }
        prepHeaders['Content-Type'] = 'application/json; charset=utf-8';
        prepHeaders['Accept'] = 'application/json; charset=utf-8';
        axios.delete(locationAPI + attribute, { headers: prepHeaders })
            .then(res => {
                resolve(res.data);
            }, err => {
                console.log('err', err);
                reject(err);
            })
    })
}
export default { get, post, put ,deleteItem};
